import { h } from 'vue';
import { Bar, mixins } from 'vue-chartjs';
import merge from 'deepmerge';

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],

  computed: {
    barOptions() {
      return merge.all([
        this.options || {},
        {
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  min: 0,
                  stepSize: 1,
                },
              },
            ],
            xAxes: [
              {
                barPercentage: 0.6,
                categoryPercentage: 1.0,
                ticks: {
                  autoSkip: false,
                },
              },
            ],
          },
        },
      ]);
    },
  },

  // Vue 3 render API: use explicit `h` to mount the canvas wrapper for vue-chartjs.
  render() {
    return h('div', { style: this.styles, class: this.cssClasses }, [
      h('canvas', {
        id: this.chartId,
        width: this.width,
        height: this.height,
        ref: 'canvas',
      }),
    ]);
  },

  mounted() {
    this.renderChart(this.chartData, this.barOptions);
  },
};
